import { render, staticRenderFns } from "./checkout-bank-slip.vue?vue&type=template&id=20cd2f9b&scoped=true"
import script from "./checkout-bank-slip.vue?vue&type=script&lang=js"
export * from "./checkout-bank-slip.vue?vue&type=script&lang=js"
import style0 from "./checkout-bank-slip.scss?vue&type=style&index=0&id=20cd2f9b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd2f9b",
  null
  
)

export default component.exports